<template>
  <div
    class="single-column">
    <section class="single-column__section">
      <h2 class="single-column__heading">パスワードの再設定</h2>
      <div
        v-if="completed"
        class="login-block">
        <div class="form-complete-area">
          <div class="form-complete-area__title">パスワードをリセットをしました。</div>
          <div class="form-complete-area__lead">新しいパスワードでログインして下さい。</div>
          <div class="form-btn-area">
            <router-link
              :to="{ name: 'top' }"
              class="c-btn c-btn--back">
              トップに戻る
              <span class="c-btn__icon-arrow"></span>
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-else-if="tokenError"
        class="login-block">
        <div class="form-complete-area">
          <div
            class="form-complete-area__title"
            style="padding-bottom: 32px">
            このURLは無効です
          </div>
          再度パスワードリセット手順を実施して下さい。
        </div>
        <div class="form-btn-area">
          <router-link
            :to="{ name: 'top' }"
            class="c-btn c-btn--back">
            トップに戻る
            <span class="c-btn__icon-arrow"></span>
          </router-link>
        </div>
      </div>
      <div
        v-else
        class="login-block">
        <form
          class="form--error"
          @submit.prevent="onRegisterClicked">
          <div class="form-wrap">
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="password">新しいパスワード（8文字以上）
                </label>
              </div>
              <div class="form-item">
                <input
                  id="password"
                  v-model="form.password"
                  class="form-control"
                  type="password"
                  name="password"
                  placeholder="半角英数のみ、8文字以上">
                <p
                  v-if="errors.password"
                  class="error-text">
                  {{ errors.password[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="password_confirmation">新しいパスワード再入力</label>
              </div>
              <div class="form-item">
                <input
                  id="password_confirmation"
                  v-model="form.password_confirmation"
                  class="form-control"
                  type="password"
                  name="password_confirmation"
                  placeholder="半角英数のみ、8文字以上">
                <p
                  v-if="errors.password_confirmation"
                  class="error-text">
                  {{ errors.password_confirmation[0] }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-btn-area">
            <button
              class="c-btn"
              type="submit"
              name="submit"
              @click.prevent="onRegisterClicked">
              設定する
              <span class="c-btn__icon-arrow"></span>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  data() {
    return {
      completed: false,
      form: {
        password: '',
        password_confirmation: '',
        token: '',
      },
      tokenError: false,
      errors: {},
    }
  },
  mounted() {
    this.verifyToken(this.$route.params.token)
  },
  methods: {

    async verifyToken(token) {
      const { data } = await window.axios.post('/api/client/verify/token', { token, type: 'password_reset' })
      if (!data.token) {
        this.tokenError = true
        return
      }
      this.form.token = data.token
      this.loading = false
    },

    async onRegisterClicked() {
      try {
        const params = this.form
        await window.axios.post('/api/client/reset-password', params)
        this.completed = true
      } catch ({ response }) {
        const { errors } = response.data
        if (response.status === 422) {
          this.errors = errors
        }
        window.scrollTo(0, 0)
      }
    },
  },
}
</script>

<style scoped>

</style>
